"use strict";
exports.__esModule = true;
exports.generateCsv = void 0;
function wrapCell(val) {
    return "\"" + val + "\"";
}
function generateCsv(logObject, logDict) {
    var lines = [
        ['"Session"', '"User"', '"IP"', '"Time"', '"Type"', '"Action"', '"Message"', '"Key"', '"Description"', '"Is User Action"']
    ];
    logObject.forEach(function (session) {
        session.actions.forEach(function (action) {
            lines.push([
                wrapCell(session.session),
                wrapCell(session.user),
                wrapCell(session.ip),
                wrapCell(action.time),
                wrapCell(action.logType),
                wrapCell(action.action),
                wrapCell(action.message),
                wrapCell(action.key),
                wrapCell(logDict[action.action] || ''),
                wrapCell(action.isUserAction)
            ]);
        });
    });
    var rs = lines.map(function (line) { return line.join(','); }).join('\r\n');
    return rs + "\r\n";
}
exports.generateCsv = generateCsv;
//# sourceMappingURL=log-process.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/pypeer-log/app/js/logic/log-process.js